import { MENU_TYPE } from './constant'

/**
 * 根据值匹配出菜单id数组：如 [1, 11]
 * @param {string} key 需要匹配的菜单键
 * @param {number|string} value 用于对比菜单键值的value
 * @param {arrar} data 菜单数组
 */
export const getKeyPathItem = (key, value, data = []) => {
  if (data.length === 0) {
    return []
  }
  let keyPath = []

  for (let i = 0; i < data.length; i++) {
    const item = data[i]

    if (item) {
      const val = key === 'id' ? value : item.id
      if (item[key] === value) {
        keyPath = keyPath.concat(val)
        break
      } else {
        const childKeyPathItem = getKeyPathItem(key, value, item.sub)
        if (childKeyPathItem.length > 0) {
          if (item.type === MENU_TYPE.ITEM_GROUP) {
            keyPath = keyPath.concat(childKeyPathItem[0])
          } else {
            keyPath = keyPath.concat(item.id, childKeyPathItem[0])
          }
          break
        }
      }
    }
  }

  return [...keyPath]
}
